import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReadCSVPriceCoursesComponent from "./ReadCSVPriceCoursesComponent";

function ReadCSVPriceCoursesPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ReadCSVPriceCoursesComponent />
      <Footer />
    </DashboardLayout>
  );
}

export default ReadCSVPriceCoursesPage;
